import * as React from 'react';
import {RouteComponentProps} from 'react-router';

import {ErrorAlert} from '../common/ErrorAlert';
import {ErrorResponse, Rental, SaveRentalResponse} from '../api/dtos/dtos';
import * as paths from '../paths';
import furoApi from '../api/FuroApi';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import RentalDetailsEditor from './RentalDetailsEditor';
import {showSaveConfirm, showSaveSuccessNotification} from 'src/utils/dialogs';
import {
  AlertController,
  bindAlertController,
  GlobalAlertContextConsumer
} from "../app/alert/GlobalAlertContextProvider";

interface CreateRentalPageState {
  editedRental?: Rental;
  error?: ErrorResponse;
}

class CreateRentalPage extends React.Component<RouteComponentProps<{}>, CreateRentalPageState> {

  public readonly loadingHandler?: LoadingOverlayHandler;
  public readonly alertController?: AlertController;

  constructor(props: RouteComponentProps<{}>) {
    super(props);
    this.state = {};
  }

  public render() {
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <GlobalAlertContextConsumer>
          {(state) => bindAlertController(state.checklist, this)}
        </GlobalAlertContextConsumer>

        <RentalDetailsEditor
          editable={true}
          mode="create"
          showChecklist={false}
          rental={this.state.editedRental}
          onRentalChange={this.onRentalChange}
          onSubmit={this.onFormSubmit}
          onCancel={this.onFormCancel}
        />

        {this.state.error && <ErrorAlert style={{marginTop: '16px'}} error={this.state.error}/>}
      </>
    );
  }

  private onRentalChange = (rental: Rental) => {
    this.setState({editedRental: rental,});
  };

  private onFormCancel = () => {
    this.props.history.goBack();
  };

  private onFormSubmit = () => {
    showSaveConfirm(this.saveFormValues);
  };

  private saveFormValues = () => {
    const {editedRental} = this.state;
    if (!editedRental) {
      return;
    }
    const promise = furoApi.rentals.create(editedRental)
      .then(this.onSaveSuccess)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onSaveSuccess = (response: SaveRentalResponse) => {
    showSaveSuccessNotification();
    this.alertController?.refreshAlertCount();
    this.props.history.replace(paths.viewRentalPath(response.rentalId));
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  }
}

export default CreateRentalPage;




// WEBPACK FOOTER //
// ./src/rental-details/CreateRentalPage.tsx